import type { SVGProps } from "react";

type IconChevronRightProps = SVGProps<SVGSVGElement> & {
  strokeWidth?: number | string;
};

/**
 * chevron-right
 * @category Arrows
 */
export default function IconChevronRightSpiky({ strokeWidth = 1.5, ...props }: IconChevronRightProps) {
  return (
    <svg viewBox='0 0 24 24' fill='none' aria-hidden='true' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path d='M9 4L17 12L9 20' stroke='currentColor' strokeLinecap='square' strokeWidth={strokeWidth} />
    </svg>
  );
}
